import { CgGym } from "react-icons/cg";

import type { PlanItem } from "~/modules/sales/schemas";
import {
	numberToBRL,
	sumTotalItemsValue,
	translatePaymentInterval,
} from "~/modules/sales/services";
import type { PagarmeInterval } from "~/modules/sales/types";

type Props = {
	data: Partial<{
		name: string;
		licensesAmount: number;
		items: PlanItem[];
		interval: PagarmeInterval;
		intervalCount: number;
	}>;
};

export const Preview: React.FC<Props> = ({ data }) => {
	return (
		<div
			className="flex gap-3 py-3 px-6 rounded-lg border-2
      border-gpa-blue-400"
		>
			<CgGym size={32} className="text-gpa-blue-400" />
			<div className="flex flex-col gap-2">
				<h2 className="text-xl font-bold">Plano {data.name}</h2>
				<p>
					<span className="font-semibold">Número de licenças</span>:{" "}
					{data.licensesAmount || 0}
				</p>
				<p>
					Valor: {numberToBRL(sumTotalItemsValue(data.items))} &bull; Cobrado{" "}
					{translatePaymentInterval(data.interval, data.intervalCount)}
				</p>
			</div>
		</div>
	);
};
